var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4361 15.4432C10.6368 15.9427 9.6001 15.3682 9.6001 14.4256V9.96512C9.6001 9.02258 10.6368 8.44796 11.4361 8.94752L15.0045 11.1778C15.7565 11.6478 15.7565 12.743 15.0045 13.213L11.4361 15.4432Z",
    fill: "url(#paint0_linear_6823_4555)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.15 20.7C17.0377 20.7 21 16.7377 21 11.85C21 6.96227 17.0377 3 12.15 3C7.26232 3 3.30005 6.96227 3.30005 11.85C3.30005 16.7377 7.26232 20.7 12.15 20.7Z",
    stroke: "url(#paint1_linear_6823_4555)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6823_4555",
    x1: 10,
    y1: 10,
    x2: 14.5,
    y2: 14.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F240A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF0175"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6823_4555",
    x1: 6.04654,
    y1: 4.22089,
    x2: 19.7793,
    y2: 20.4967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F240A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF0175"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemplay);
export default __webpack_public_path__ + "static/media/itemplay.d056825a9e69a105d13e05d70e50e811.svg";
export { ForwardRef as ReactComponent };